<template>
    <modal ref="modal" :modal-backdrop="true">
        <template #body>
            <div class="mb-6">
                <div class="mb-6">
                    Olá,
                    <span v-if="user.professional.sex == 'm'">Dr.</span>
                    <span v-else-if="user.professional.sex == 'f'">Dra.</span>
                    <span v-else>Dr(a).</span>
                    {{ user.name }}!
                </div>
                <div class="mb-6">
                    Gostaríamos de informar que se faz necessário que você atualize sua foto de perfil no sistema ah.life.
                </div>
                <div class="mb-4">
                    É essencial que você conclua esse processo o quanto antes
                </div>
                
            </div>
            <div class="flex justify-end">                
                <button type="button" class="btn-primary font-normal ml-1" @click.prevent="confirm">Atualizar foto de perfil</button>
            </div>
        </template>
    </modal>
</template>
<script>
import { ref, computed } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal/Modal'

export default {
  components: {
    Modal,
  },
  setup(props, context) {
    const user = computed(() => usePage().props.value.auth.user)

    const modal = ref(null);

    const openModalUpdatePhotoProfile = () => {
      modal.value.showModal = true;
    }

    const closeUpdatePhotoProfile = () => {
      modal.value.showModal = false;
    }

    return {
      openModalUpdatePhotoProfile,
      closeUpdatePhotoProfile,
      modal,
      user
    }
  },
  methods: {
    async confirm() {
      this.close();
      this.$inertia.visit('/profile');
    },
    open() {
      this.$refs.modal.showModal = true;
    },
    close() {
      this.$refs.modal.showModal = false;
    }
  },
}
</script>
<style></style>